import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core'
import { Formik } from 'formik'
import { isEmpty } from 'lodash'
import React, { useState } from 'react'
import { object, string } from 'yup'

import ButtonSubmit from '../common/ButtonSubmit'

const MAX_DELIVERY_INSTRUCTION_LIMIT = 60
const schema = object().shape({
  deliveryInstructions: string().required(),
})

export const DialogDeliveryInstructions = ({
  curSavedLocation,
  isUpdatingSavedLocation,
  showDeliveryInstructionsDialog,
  showOnEmptyDeliveryInstructions = false,
  toggleDeliveryInstructionsDialog,
  updateSavedLocationError,
  updateUserSavedLocationStart,
}) => {
  const [instrCount, setInstrCount] = useState(0)
  const [dismissed, setDismissed] = useState(false)

  const dialogOpen = Boolean(
    (showOnEmptyDeliveryInstructions &&
      isEmpty(curSavedLocation?.deliveryInstructions) &&
      curSavedLocation?.deliveryInstructionsSupported &&
      !dismissed) ||
      showDeliveryInstructionsDialog,
  )

  const handleClose = () => {
    setDismissed(true)
    showDeliveryInstructionsDialog && toggleDeliveryInstructionsDialog()
  }
  const handleSubmit = values => {
    updateUserSavedLocationStart(
      curSavedLocation.savedLocationId,
      null,
      values.deliveryInstructions,
    )
  }

  return (
    <Formik
      initialValues={{ deliveryInstructions: curSavedLocation?.deliveryInstructions ?? '' }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, touched }) => (
        <Dialog
          disableBackdropClick={isUpdatingSavedLocation}
          disableEscapeKeyDown={isUpdatingSavedLocation}
          fullWidth
          onClose={handleClose}
          open={dialogOpen}
        >
          <DialogTitle disableTypography>
            <Typography variant="h5">Provide delivery instructions</Typography>
            <Typography component="p" variant="body1">
              Provide any additional information drivers may need to deliver to your location.
            </Typography>
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              defaultValue={curSavedLocation?.deliveryInstructions ?? ''}
              error={Boolean(errors.deliveryInstructions)}
              fullWidth
              helperText={
                <Box component="span" display="flex" justifyContent="flex-end">
                  <Typography variant="caption">
                    {instrCount} / {MAX_DELIVERY_INSTRUCTION_LIMIT} characters
                  </Typography>
                </Box>
              }
              id="deliveryInstructions"
              inputProps={{ maxLength: MAX_DELIVERY_INSTRUCTION_LIMIT }}
              label="Delivery Instructions"
              multiline
              onBlur={handleBlur}
              onChange={e => {
                setInstrCount(e.target.value.length)
                handleChange(e)
              }}
              placeholder="Door code, who to ask for when we arrive, etc…"
              rowsMax={3}
              variant="outlined"
              color="secondary"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Dismiss</Button>
            <ButtonSubmit
              color="secondary"
              disabled={isUpdatingSavedLocation}
              onClick={handleSubmit}
              submitting={isUpdatingSavedLocation}
            >
              Submit
            </ButtonSubmit>
          </DialogActions>
          {updateSavedLocationError && (
            <Typography align="center" color="error">
              {updateSavedLocationError}
            </Typography>
          )}
          <Box paddingY={2} />
        </Dialog>
      )}
    </Formik>
  )
}

export default DialogDeliveryInstructions
